<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/htgl2.png" class="steps step1" v-if="status==1">
            <img src="../../../assets/images/htgl1.png" class="steps step2" v-if="status==2">
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <breadcrumb :routerList="[{to:'/contract-list',title:'合同管理'},{title:'新建线下合同'}]"/>
        <div class="h-piece">
            <div class="outerCon">
                <div class="tabBtn" :class="{tabBtnAc:tabIndex == '1'}" @click="tabchange(1)">合同</div>
             <!--   <div class="tabBtn" :class="{tabBtnAc:tabIndex == '3'}" @click="tabchange(3)">目标</div>
                <div class="tabBtn" :class="{tabBtnAc:tabIndex == '2'}" @click="tabchange(2)">目标对阵</div>-->
            </div>
<!--          合同-->
            <div class="h-formLine weekplandetail23" v-if="tabIndex == '1'">
                <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;">
                    <h1>合同详情</h1>
                </div>
                <el-form label-position="right" :model="formInline" ref="form1" :rules="rules" label-width="120px"
                         class="h-form">
                  <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="合同编码" prop="Id">
                          <el-input v-model.number="formInline.id" :disabled="disabled"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="合同名称" prop="contractName">
                          <el-select v-model="formInline.contractName" style="width: 100%" placeholder="请选择" @change="changeDlsType">
                              <el-option value="国内市场线上矩阵合同">国内市场线上矩阵合同</el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="经销商合同类型" prop="contractAgent">
                          <brselect category="contract_xianshang" @input="changeCatogory" :v="formInline.contractAgent"
                                    v-model="formInline.contractAgent" :disabled="disabled" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="对阵一级经销商" prop="oneLevelAgentName"
                                      v-if="(formInline.contractAgent==8 || formInline.contractAgent == 2) &&  tabIndex=='1'">
                          <el-select v-model="formInline.oneLevelAgentName"
                                     :title="formInline.oneLevelAgentName"
                                     remote filterable :filter-method="showAgentList" clearable placeholder="请输入"
                                     :remote-method="showAgentList" @change="changeAgent($event)">
                            <el-option v-for="(item) in oneAgentList"
                                       :key="item.customerName"
                                       :label="item.customerName"
                                       :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="客户名称" prop="customerCode">
                          <el-input v-model="formInline.customerName" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="线上渠道" prop="salechannelCode">
                          <brselect :multiple="true" category="xinshangpingtai"
                                    :v="formInline.salechannelCode"
                                    :disabled="disabled"
                                    v-model="formInline.salechannelCode"
                                    :clearable="true"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                          <el-form-item label="操盘手" class="h-elformWrap-2" prop="productCode">
                              <el-input v-model="formInline.productCode" :disabled="disabled" placeholder="请填写"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="6">
                          <el-form-item label="联系方式" class="h-elformWrap-2" prop="productName">
                              <el-input v-model="formInline.productName" :disabled="disabled" placeholder="请填写"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="6">
                          <el-form-item label="所属区域" class="h-elformWrap-2" prop="saleareaCode">
                              <el-input v-model="formInline.saleareaCode" :disabled="disabled" placeholder="请填写"></el-input>
                          </el-form-item>
                      </el-col>
                  </el-row>
                  <div class="h-formBox salesCityStyle">
                    <el-row :gutter="20" v-for="(listIt, index) in formInline.salesCityList" :key="index">
                      <el-col :span="6">
                        <el-form-item label="销售平台" prop="salesCityName">
                          <el-input v-model="formInline.salesCityList[index].salesCityName" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="业务人员" prop="yewuname">
                          <el-input v-model="formInline.salesCityList[index].yewuname" placeholder="请输入数字" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="联系方式" prop="phone">
                          <el-input v-model="formInline.salesCityList[index].phone" placeholder="请输入数字" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <el-form-item label="合同金额(万元)" prop="contractAmount">
                        <el-input v-model.number="formInline.contractAmount" :disabled="disabled"
                                  placeholder="请输入数字">
                          <i slot="prefix" style="font-style: normal; font-weight: bold;">￥</i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="合同开始时间" prop="contractStarttime">
                        <el-date-picker :clearable="false" type="date" placeholder="选择时间"
                                        v-model="formInline.contractStarttime"
                                        :picker-options="pickerOptions1" @change="setZlDate()"
                                        :disabled="disabled"></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="合同结束时间" prop="contractEndtime">
                        <el-date-picker :clearable="false" type="date" placeholder="选择时间"
                                        v-model="formInline.contractEndtime"
                                        :picker-options="pickerOptions2" :disabled="disabled"></el-date-picker>
                      </el-form-item>
                    </el-col>
                      <el-col :span="6">
                          <el-form-item label="是否增量" prop="isIncrement" class="h-elformWrap-2" v-if="formInline.contractName=='国内市场经销合同'">
                              <el-radio-group v-model="formInline.isIncrement" :disabled="disabled">
                                  <el-radio :label="1">是</el-radio>
                                  <el-radio :label="0">否</el-radio>
                              </el-radio-group>
                          </el-form-item>
                      </el-col>

                      <el-col :span="6">
                          <el-form-item label="增量赋能平台" v-if="formInline.isIncrement === 1 && formInline.contractName=='国内市场经销合同'"
                                        class="h-elformWrap-2" prop="incrementPt">
                              <brselect category="incrementPt" :v="formInline.incrementPt"
                                        v-model="formInline.incrementPt" :disabled="disabled"></brselect>
                          </el-form-item>
                      </el-col>
                  </el-row>

                    <el-form-item label="产业" class="h-elformWrap-1" prop="lianqun" v-if="formInline.contractName=='国内市场经销合同' && (formInline.contractAgent == 3
                    || formInline.contractAgent == 10 || formInline.contractAgent == 14 || formInline.contractAgent == 4 || formInline.contractAgent == 9 || formInline.contractAgent == 5 || formInline.contractAgent == 6 || formInline.contractAgent == 7
                    || formInline.contractAgent == 11 || formInline.contractAgent == 12 || formInline.contractAgent == 13
                    )">
                        <el-checkbox-group v-model="lianqunList" disabled>
                            <el-checkbox label="C1">超低温&低温&冻干机</el-checkbox>
                            <el-checkbox label="C2">疫苗网</el-checkbox>
                            <el-checkbox label="C3">数智医疗</el-checkbox>
                            <el-checkbox label="C4">数智科研</el-checkbox>
                            <el-checkbox label="C6">样本网</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item label="产业" class="h-elformWrap-1" prop="lianqun" v-if="formInline.contractName=='国内市场经销合同-朗康'">
                        <el-checkbox-group v-model="lianqunList" disabled>
                            <el-checkbox label="C8">朗康-传统</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item label="产业" class="h-elformWrap-1" prop="lianqun" v-if="formInline.contractName=='国内市场经销合同-血液' && (formInline.contractAgent == 3
                    || formInline.contractAgent == 10 || formInline.contractAgent == 14 || formInline.contractAgent == 4 || formInline.contractAgent == 9 || formInline.contractAgent == 5 || formInline.contractAgent == 6 || formInline.contractAgent == 7
                    || formInline.contractAgent == 11 || formInline.contractAgent == 12 || formInline.contractAgent == 13
                    )">
                        <el-checkbox-group v-model="lianqunList" disabled>
                            <el-checkbox label="C5">血液网</el-checkbox>
                            <el-checkbox label="C7">血液网-传统</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                  <el-form label-position="right" :model="file" :rules="rules" label-width="120px"
                               class="h-form">
                        <el-row :gutter="20">
                          <el-col :span="10">
                            <el-form-item label="主合同文件" prop="name">
                              <brupload :refid="this.contractId" reftype="合同附件" :uploadflag="fileFlag"
                                        :delflag="fileFlag"
                                        :tpFlag='true' :isTpAndPdf='true'
                              ></brupload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="10">
                            <el-form-item class="saleFile" label="合同工程专业承包资质" v-if="isKa" prop="name">
                              <brupload :refid="this.contractId" reftype="合同工程专业承包资质" :uploadflag="fileFlag"
                                        :delflag="fileFlag"
                                        :tpFlag='true' :isTpAndPdf='true'
                              ></brupload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-form>
                  <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;" v-if="formInline.contractAgent == 1 && formInline.contractName!='国内市场经销合同-朗康'">
                      <h1>产业合同</h1>
                  </div>
                  <el-form label-position="right" :model="formInline" ref="form2" :rules="rules" label-width="80px"
                           class="h-form">
                      <div v-for="(listIt, index) in formInline.industryList" :key="index" class="h-formBox industryBox" v-if="formInline.contractAgent == 1 && formInline.contractName!='国内市场经销合同-朗康'">
                        <el-row :gutter="24">
                          <el-col :span="5">
                            <el-form-item label="产业" prop="industry">
                              <brselect category="swyl_industry"
                                        :v="formInline.industryList[index].industry"
                                        :disabled="disabled"
                                        v-model="formInline.industryList[index].industry"
                                        :clearable="true"
                              />
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item label="销售区域" prop="saleareaCode" v-if="listIt.industry">
                              <brselect category="YlSalesArea_chanpin" :v="formInline.industryList[index].saleareaCode"
                                        v-model="formInline.industryList[index].saleareaCode"
                                        :disabled="disabled"></brselect>
                            </el-form-item>
                          </el-col>
                          <el-col :span="7">
                            <el-form-item label="销售地市" prop="salesCity" :prop="`industryList[${index}].salesCityName`">
                              <el-input v-model="formInline.industryList[index].salesCityName"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="7">
                            <el-form-item label="销售渠道" prop="channel" v-if="listIt.industry">
                              <brselect :multiple="true" category="sales_region"
                                        :v="formInline.industryList[index].channel"
                                        :disabled="disabled"
                                        v-model="formInline.industryList[index].channel"
                              />
                            </el-form-item>
                          </el-col>
                          <el-col :span="5">
                            <el-form-item label="用户个数" prop="userNum" v-if="listIt.industry">
                              <el-input v-model.number="formInline.industryList[index].userNum" :disabled="disabled"
                                        placeholder="请输入数字"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                              <el-form-item class="saleFile" prop="contractAmount" v-if="listIt.industry">
                                <template #label>
                                  <div class="custom-label">
                                    <div class="label-line">合同金额</div>
                                    <div class="label-line unit">（万元）</div>
                                  </div>
                                </template>
                                  <el-input v-model.number="formInline.industryList[index].contractAmount" :disabled="disabled && update!=2"
                                            placeholder="请输入数字"></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="10">
                              <el-form-item class="saleFile" style="width: 100%;" prop="id"  v-if="listIt.industry">
                                <template #label>
                                  <div class="custom-label">
                                    <div class="label-line">产业合同</div>
                                    <div class="label-line unit">附件</div>
                                  </div>
                                </template>
                                <brupload :refid="contractId+formInline.industryList[index].industry" reftype="合同附件" :uploadflag="!disabled"
                                            :delflag="!disabled"
                                            :tpFlag='true' :isTpAndPdf='true'
                                  ></brupload>
                              </el-form-item>
                          </el-col>
                        </el-row>
                          <el-row :gutter="24">
                              <el-col :span="6">
                                  <el-form-item
                                          v-if="listIt.industry  && listIt.status != null && listIt.status != ''"
                                          prop="status"
                                          label="审批状态"
                                  >
                                      <span style="font-size: 12px" v-if="formInline.industryList[index].status === '1'">正常</span>
                                      <span style="font-size: 12px" v-else-if="formInline.industryList[index].status === '2'">审批中</span>
                                      <span style="font-size: 12px" v-else-if="formInline.industryList[index].status === '3'">驳回</span>
                                      <span style="font-size: 12px" v-else>未提交</span>
                                      <el-button
                                          type="text" style="font-size: 12px;margin-left: 20px"
                                          v-if="listIt.industry && null != listIt.instid && '' != listIt.instid && listIt.status != null && listIt.status != ''"
                                          @click="genzongLiuch(formInline.industryList[index].instid)">
                                        审批跟踪
                                      </el-button>
                                  </el-form-item>

                              </el-col>
                          </el-row>
                      </div>
                      <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;"  v-if="formInline.reason != null && formInline.reason != ''">
                          <h1>修改原因</h1>
                      </div>
                      <el-row :gutter="24">
                          <el-col :span="10">
                              <el-form-item label="修改原因" class="h-elformWrap-2 w-elformWrap" prop="reason" v-if="formInline.reason != null && formInline.reason != ''">
                                  <el-input type="textarea" v-model="formInline.reason" :clearable="true" style="margin-left:0.1rem;" disabled></el-input>
                              </el-form-item>
                              <el-form-item label="修改证明" class="h-elformWrap-2" prop="upload10" v-if="formInline.reason != null && formInline.reason != ''">
                                  <brupload
                                          :refid="formInline.refidxg"
                                          reftype="经销商框架合同-修改附件"
                                          :uploadflag = "false"
                                          :delflag = "false"
                                          :showtime="false"
                                          :isTpAndPdf = 'true'
                                          :tpFlag = 'true'
                                  >
                                  </brupload>
                              </el-form-item>
                          </el-col>
                      </el-row>
                  </el-form>
                  <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;"
                       v-if="this.formInline.pid != null && this.formInline.pid != '' || this.formInline.pass == 2">
                      <h1>销售目标及目标对阵用户详情</h1>
                  </div>
                    <el-form label-position="right" :model="file" :rules="rules" :inline="true"  class="demo-ruleForm h-formbLine" v-if="this.formInline.pid != null && this.formInline.pid != '' || this.formInline.pass == 2">
                        <el-form-item label="子合同文件" class="h-elformWrap-1 h-formRbtnOut h-formRbtnOut2" style="width: 100%;" prop="name">
                            <brupload :refid="this.contractId" reftype="销售目标及目标对阵用户详情" :uploadflag="fileFlag" :delflag="fileFlag"
                                      :tpFlag = 'true' :isTpAndPdf = 'true'
                            ></brupload>
                        </el-form-item>
                    </el-form>

                    <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;"
                         v-if="this.formInline.pass == 1">
                        <h1>销售目标及目标对阵用户详情</h1>
                    </div>
                    <el-form label-position="right" :model="file" :rules="rules" :inline="true"  class="demo-ruleForm h-formbLine" v-if="this.formInline.pass == 1">
                        <el-form-item label="详情附表" class="h-elformWrap-1 h-formRbtnOut h-formRbtnOut2" style="width: 100%;" prop="name">
                            <brupload :refid="this.contractId" reftype="销售目标及目标对阵用户详情" :uploadflag="fileFlag" :delflag="fileFlag"
                                      :tpFlag = 'true' :isTpAndPdf = 'true'
                            ></brupload>
                        </el-form-item>
                    </el-form>
                </el-form>
                <div class="h-txtCenter h-mrt60" v-if="!disabled">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="submit('1')">暂存</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submit('0')" v-if="!isFb">确认提交</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="fbSubmit('0')" v-if="isFb">确认提交附表</el-button>
                </div>
            </div>
<!--          目标-->
            <el-table
                    ref="multipleTable"
                    v-show="tabIndex == '2'"
                    :data="tableData2"
                    :border="true"
                    stripe
                    max-height="560"
                    style="width: 100%">
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        label="序号"
                        type="index"
                        fixed
                        width="50">
                </el-table-column>
                <el-table-column prop="year" label="年份" width="60px"></el-table-column>
                <el-table-column prop="province" label="省份" width="90px"></el-table-column>
                <el-table-column prop="city" label="地市" width="90px"></el-table-column>
                <el-table-column prop="scenesName" label="渠道" width="90px"></el-table-column>
                <el-table-column prop="agentName" label="经销商" width="150px"
                                 :show-overflow-tooltip="true"></el-table-column>
                <!-- <el-table-column prop="contractId" label="经销商合同" width="120px"></el-table-column> -->
                <el-table-column prop="customerName" label="用户名称" width="180px" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{scope.row.customerName}}
                    </template>
                </el-table-column>
                <el-table-column prop="incomeTarget" label="预计目标收入(万元)" width="100px"></el-table-column>
                <el-table-column prop="distributorUsers" label="分销商3.0" width="150px"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="facingyewuyuan" label="对阵业务员" width="100px"></el-table-column>
                <el-table-column prop="isTop" label="是否TOP" width="100px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isTop == 0">否</span> <span v-if="scope.row.isTop == 1">是</span>
                    </template>
                </el-table-column>
                <el-table-column prop="memo" label="子场景" width="110px" :show-overflow-tooltip="true"></el-table-column>

                <el-table-column prop="status" label="状态" width="120px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.delflag == 1">
                            <span v-if="scope.row.status == 1 && scope.row.delflag == 1">正常</span>
                            <span v-if="scope.row.status == 2 && scope.row.delflag == 1">审核中</span>
                            <span v-if="scope.row.status == 3 && scope.row.delflag == 1">作废</span>
                            <span v-if="scope.row.status == 0 && scope.row.delflag == 1">已删除</span>
                        </div>
                        <div v-if="scope.row.delflag == 0">
                            <span v-if="scope.row.delflag == 0">已删除</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="agentLevel" label="经销商类型" width="110px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.agentLevel == 1">一级经销商</span>
                        <!-- <span v-if="scope.row.agentLevel == 2">分销商</span> -->
                        <span v-if="scope.row.agentLevel == 3">专营商</span>
                        <!-- <span v-if="scope.row.agentLevel == 4">直单用户</span>
                        <span v-if="scope.row.agentLevel == 5">分销商3.0</span> -->
                        <span v-if="scope.row.agentLevel == 6">地市直营商</span>
                    </template>
                </el-table-column>
                <el-table-column prop="againstMode" label="对阵模式" width="150px">
                    <template slot-scope="scope">
                        {{scope.row.againstMode|dictname('against_mode')}}
                    </template>
                </el-table-column>
                <el-table-column prop="facingReseller" label="对阵分销商1.0" width="100px"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="cuname" label="创建人" width="100px"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="cdate" label="创建时间" width="140px"></el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30" v-if="tabIndex == '2'">
                <div class="h-tableBL">
                    <!--<div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcelAll">批量导出
                        </el-button>
                        <uploaddownexcel
                                :visible.sync="uploaddownexcelflag"
                                v-if="uploaddownexcelflag"
                                clsname="bscTargetAgainstUserExcel"
                                :startrow="2" @callback="uploadExcelFilecallback"/>
                    </div>-->
                </div>
                <div class="h-pagination2">
                    <pagination :page="q2" @query="selectPageAll"/>
                </div>
            </div>
<!--          目标对阵-->
            <el-table
                    ref="ddtable"
                    v-show="tabIndex == '3'"
                    :data="tableData3"
                    stripe
                    style="width: 100%"
                    :border="true"
                    max-height="520"
            >
                <el-table-column
                        type="index"
                        label="#"
                        fixed
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="year"
                        label="年"
                        :show-overflow-tooltip="true"
                        width="70">
                </el-table-column>
                <el-table-column
                        prop="area"
                        label="区域"
                        :show-overflow-tooltip="true"
                        width="60">
                </el-table-column>
                <el-table-column
                        prop="agentCode"
                        label="经销商编码"
                        :show-overflow-tooltip="true"
                        fixed
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="agentName"
                        label="经销商名称"
                        :show-overflow-tooltip="true"
                        fixed
                        width="180">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.agentName}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="agentType"
                        label="经销商类型"
                        :show-overflow-tooltip="true"
                        width="100">
                    <template slot-scope="scope">
                        {{scope.row.agentType|dictname('fl_agent_type')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="salesRegionCode"
                        label="渠道"
                        :show-overflow-tooltip="true"
                        width="100">
                    <template slot-scope="scope">
                        {{scope.row.salesRegionCode|dictname('fl_sales_region_qudao')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="rebateChainGroup"
                        label="链群"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template slot-scope="scope">
                        <div v-if="scope.row.rebateChainGroup=='cthj'">传统</div>
                        <div v-if="scope.row.rebateChainGroup!='cthj'">
                            {{scope.row.rebateChainGroup|dictname('rebate_chain_group')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="qunianTongqi"
                        label="去年同期(万元)"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.qunianTongqi}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="jinnianGoal"
                        label="今年目标(万元)"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.jinnianGoal}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="1月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume1"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume1}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal1"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal1}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="2月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume2"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume2}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal2"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal2}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="3月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume3"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume3}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal3"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal3}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="4月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume4"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume4}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal4"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal4}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="5月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume5"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume5}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal5"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal5}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="6月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume6"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume6}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal6"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal6}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="7月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume7"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume7}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal7"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal7}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="8月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume8"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume8}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal8"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal8}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="9月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume9"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume9}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal9"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal9}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="10月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume10"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume10}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal10"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal10}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="11月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume11"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume11}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal11"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal11}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="12月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume12"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume12}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal12"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal12}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column
                        prop="planStatus"
                        label="审批状态"
                        width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.planStatus == 1">平台审批中</div>
                        <div v-if="scope.row.planStatus == 2">审批通过</div>
                        <div v-if="scope.row.planStatus == 3">驳回</div>
                        <div v-if="scope.row.planStatus == 4">省区经理审批中</div>
                        <div v-if="scope.row.planStatus == 5">总监审批中</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="statu"
                        label="有效性"
                        :show-overflow-tooltip="true"
                        width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.statu == 2">有效</div>
                        <div v-if="scope.row.statu == 5">已退出</div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30" v-if="tabIndex == '3'">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               @click="exportTargetExcel" v-auth="'fl_goal_pldc'">批量导出
                    </el-button>
                </div>
                <div class="h-pagination2">
                    <pagination :page="q3" @query="queryMb"/>
                </div>
            </div>
        </div>
        <div class="bannerBox2" v-if="chankanflag">
            <div class="h-row h-mrt1">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;">
                                    <h1>审核信息</h1>
                                </div>
                                <div class="h-pieceCon2 ">
                                    <div class="h-formLine weekplandetail11" style="position: relative;">
                                        <el-form :model="formInline" label-width="120px" class="h-form">
                                          <el-row :gutter="20">
                                            <el-col :span="20">
                                              <el-form-item label="审批意见">
                                                <el-input
                                                    v-model="formInline.auditMind2"
                                                    placeholder="请输入" />
                                              </el-form-item>
                                            </el-col>
                                          </el-row>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style="text-align: center;margin-top: 0.3rem" v-if="this.disabled">
            <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default"
                       v-if="!this.daquflag && !this.lastflag"
                       @click="cancel">返回
            </el-button>
            <el-button class="h-btn h-bBtn h-bgred"
                       @click="daquPass(2)" v-if="this.daquflag && this.formInline.pass != 2">驳回
            </el-button>
            <el-button class="h-btn h-bBtn h-bggreen" v-if="this.daquflag && this.formInline.pass != 2"
                       @click="daquPass(1)">通过
            </el-button>
            <el-button class="h-btn h-bBtn h-bgred"
                       @click="contractPass(2)" v-if="this.lastflag && this.formInline.pass != 2">驳回
            </el-button>
            <el-button class="h-btn h-bBtn h-bggreen" v-if="this.lastflag && this.formInline.pass != 2"
                       @click="contractPass(1)">通过
            </el-button>

            <el-button class="h-btn h-bBtn h-bgred"
                       @click="passFb(2)" v-if="this.formInline.pass == 2 && this.instid != null && this.instid != ''">驳回
            </el-button>
            <el-button class="h-btn h-bBtn h-bggreen" v-if="this.formInline.pass == 2 && this.instid != null && this.instid != ''" @click="passFb(1)">通过
            </el-button>

            <el-button class="h-btn h-bBtn" @click="viewpress">
                审批跟踪
            </el-button>

        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory"
                     :id="instid"/>
    </div>

</template>

<script>
    import big from 'big.js';
    import ss from "../../../api/SystemService";
    import util from "../../../utils/util";

    export default {
        name: 'leftMenu',
        data() {
            return {
                // 新手引导页
                toshow: "contract-agent.vue",
                checked: true,
                status: 1,
                showOrhide: false,
                contractId: null,
                guanlianxiangmFlag: true,

                optionsProduct2_jzx: [],
                optionsProduct2: [],
                optionsProduct1: [],
                lianqunList: [],
                qudao: [],
                customerlabel: "客户名称",
                allProjectByUser: [],
                tempProject: [],
                tempProject2: [],
                zlflag: false,
                bzflag: false,
                dlsflag: false,
                tabIndex: null,
                showhistory: false,
                shichang: true,
                isCt: false,
                pickerOptions1: {
                    disabledDate: (time) => {
                        return time.getTime() < Date.now() - 86400000;
                    }
                },
                pickerOptions2: {
                    disabledDate: (time) => {
                        if (this.formInline.contractCatecory == "CT-DLS-KJ" || this.formInline.contractCatecory == "经销商框架合同") {
                            return time.getTime() < Date.now() - 8.64e7;
                        } else if (this.formInline.contractStarttime != "") {
                            return time.getTime() < this.formInline.contractStarttime;
                        }
                    }
                },
                //表单
                formInline: {
                    zltype: "",
                    contractName: null,
                    pid: "",
                    customerCode: "",
                    salechannelCode: null,
                    contractCatecory: "CT-DLS-KJ",
                    contractAmount: "",
                    contractStatus: "",
                    contractStarttime: "",
                    contractEndtime: "",
                    contractCashPledge: "",
                    productCode: "",
                    productName: "",
                    productPrice: "",
                    productType: "",
                    rentNum: "",
                    rentTime: "",
                    guaranteeTime: "",
                    productList: [],
                    zsyzq: "",
                    rentType: "",
                    isShhm: 0,
                    isJj: 0,
                    rentPlace: "",
                    returnPlace: "",
                    rentPrice: "",
                    contractAgent: "",
                    auditMind2: "",
                    status: "",
                    isZc: "",
                    saleareaCode: null,
                    lianqun: "",
                    salesCity: "",
                    incrementPt: "",
                    isIncrement:null,

                    salesCityList: [
                        {
                            salesCity: "",
                            yewuname: "",
                            phone: "",
                            salesCityName:""
                        },
                    ],
                    industryList: [
                        {
                            industry: "",
                            channel: "",
                            userNum: "",
                            saleareaCode: "",
                            salesCity: "",
                            salesCitys: []
                        },
                    ],

                },
                formInline1: {
                    wuliufangshi: 2,
                    condition: []
                },
                customerList: [],
                salesCity: [],
                fieldList: [
                    {name: '医疗创新领域', code: 'L1'},
                    {name: '生命科学领域', code: 'L2'}
                ],
                //多选
                checkList: [],
                fileList: [],
                oneAgentList: [],
                channels: null,
                file: {
                    name: ''
                },
                rules: {
                    contractName: [
                        {required: true, message: '请输入合同名称', trigger: 'blur'},
                    ],
                    oneLevelAgentName: [
                        {required: true, message: '请输入对阵经销商', trigger: 'blur'},
                    ],
                    contractCatecory: [
                        {required: true, message: '请选择合同类型', trigger: 'change'},
                    ],
                    contractStarttime: [
                        {required: true, message: '请输入合同开始时间', trigger: 'blur'},
                    ],
                    contractEndtime: [
                        {required: true, message: '请输入合同结束时间', trigger: 'blur'},
                    ],
                    salechannelCode: [
                        {required: true, message: '请选择销售渠道', trigger: 'change'},
                    ],
                    caigouquyu: [
                        {required: true, message: '请选择领域', trigger: 'change'},
                    ],
                    saleareaCode: [
                        {required: true, message: '请选择销售省份', trigger: 'change'},
                    ],
                    salesCity: [
                        {required: true, message: '请选择销售地市', trigger: 'change'},
                    ],
                },
                jzxFlag: false,
                rentTimeList: [],
                taskid: null,
                instid: null,
                isFb: false,
                disabled: false,
                chankanflag: false,
                fileFlag: true,
                daquflag: false,
                lastflag: false,
                isCt1: false,
                isNA9: false,
                isKs1: false,
                isSj1: false,
                isHh1: false,
                isXueYe: false,
                isKa: false,
                q2: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    contractId: null,
                    customerName: null
                },
                q3: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    contractId: null,
                    agentNameLike: null,
                    year: 2025,
                },
                uploaddownexcelflag: false,
                tableData2: [],
                tableData3: [],
            }
        },
        methods: {
            save() {
                this.formInline.editStatus = 0;
                var cond = this.formInline1.condition;
                this.formInline.payCondition = cond.join(",");
                this.formInline.contractType = 0;
                this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
                this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
                this.formInline.wuliufangshi = this.formInline1.wuliufangshi;
                if (cate == "CT-ZL" && this.formInline.zltype == '3') {
                    var totalMoney = new big(0);
                    if (this.formInline.zlList) {
                        this.formInline.zlList.forEach((obj) => {
                            totalMoney = totalMoney.plus(new big(obj.productTotalPrice));
                        })
                    }
                    this.formInline.contractAmount = totalMoney;
                }
                this.formInline.zlList = this.formInline.zlList;
                ss.contractService.insertAgent(this.formInline).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs("保存成功！");
                        this.$router.push("contract-list");
                    } else {
                        this.$msg.msgs("保存失败！" + rd.msg);
                    }
                });
            },
            genzongLiuch(q) {
                this.instid = q;
                this.showhistory = true;
            },

            passFb(query) {
                this.formInline.aaa = query;
                this.formInline.salesCity = this.citys;
                this.formInline.taskid = this.taskid;
                this.formInline.instid = this.instid;
                this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
                this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
                ss.contractService.contractFbPass(this.formInline).then(rd => {
                    this.$msg.alerts("提交成功！", () => {
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列表
                        this.$router.push({
                            path: '/personal/dealCenter'
                        })
                    })
                })
            },
            submit(rd) {
                var subflag1 = false;
                this.$refs['form1'].validate((valid) => {
                    if (valid) {
                        subflag1 = true;
                    } else {
                        this.$msg.msge("请完善合同信息后再提交！")
                        return false;
                    }
                });
                if (!subflag1) {
                    return;
                }
                console.log("节点", 1)
                var cate = this.formInline.contractCatecory;
                this.formInline.salesCity = this.citys;
                this.formInline.isZc = rd;
                this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
                this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
                ss.contractService.getDlsContract(this.formInline).then(rd => {
                    console.log(rd);
                    //存在合同
                    if (rd.msg > 0) {
                        this.$msg.confirm("当前经销商存在" + rd.msg + "条可用合同,如果重复请作废!确定要提交吗？", () => {
                            this.formInline.editStatus = 1;
                            this.formInline.contractType = 0;
                            this.formInline.wuliufangshi = this.formInline1.wuliufangshi;
                            console.log(1211, this.formInline);
                            ss.contractService.insertAgent(this.formInline).then(rd => {
                                if (rd.f) {
                                    this.$msg.msgs("提交成功！");
                                    this.$router.push("contract-list");
                                } else {
                                    this.$msg.msgs("提交失败！" + rd.msg);
                                }
                            })
                        })
                    } else {
                        this.$msg.confirm("确定要提交吗？", () => {
                            this.formInline.editStatus = 1;
                            this.formInline.contractType = 0;
                            this.formInline.wuliufangshi = this.formInline1.wuliufangshi;
                            console.log(1211, this.formInline);
                            ss.contractService.insertAgent(this.formInline).then(rd => {
                                if (rd.f) {
                                    this.$msg.msgs("提交成功！");
                                    this.$router.push("contract-list");
                                } else {
                                    this.$msg.msgs("提交失败！" + rd.msg);
                                }
                            })
                        })
                    }
                })
            },
            viewpress() {
                this.showhistory = true;
            },
            isEmpty(attr) {
                if (attr == null || attr == "") {
                    return true;
                } else {
                    return false;
                }
            },
            isNotEmpty(attr) {
                if (attr != null && attr != "") {
                    return true;
                } else {
                    return false;
                }
            },
            changeCatogory(attr) {

            },
            getLianquns(s) {
                var m = s.split(',');
                if (m.length <= 0) {
                    this.lianqunList = ''
                } else {
                    this.lianqunList = m
                }
                if (this.formInline.lianqun.includes("X02") || this.formInline.lianqun.includes("X01")
                    || this.formInline.lianqun.includes("X08") || this.formInline.lianqun.includes("X09") || this.formInline.lianqun.includes("X10")
                    || this.formInline.lianqun.includes("X05") || this.formInline.lianqun.includes("X06")
                ) {
                    this.isCt = true;
                } else {
                    this.isCt = false;
                }
            },
            getCity(s) {
                var s1 = s;
                var m = s1.split(',');
                if (m.length <= 0) {
                    this.formInline.salesCity = ''
                } else {
                    this.formInline.salesCity = m
                }
                this.citys = s;
            },
            formatDate(date) {
                if (this.isNotEmpty(date)) {
                    function addDateZero(num) {
                        return (num < 10 ? "0" + num : num);
                    }

                    let d = new Date(date);
                    let format = d.getFullYear() + "-" + addDateZero(d.getMonth() + 1) + "-" + addDateZero(d.getDate());
                    return format;
                }
            },
            daquPass(query) {
                this.formInline.aaa = query;
                this.formInline.taskid = this.taskid;
                this.formInline.instid = this.instid;
                this.formInline.salesCity = "";
                this.formInline.salesCityList = [];
                this.formInline.industryList = [];
                ss.contractService.daquPass(this.formInline).then(rd => {
                    this.$msg.alerts("提交成功！", () => {
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列表
                        this.$router.push({
                            path: '/personal/dealCenter'
                        })
                    })
                })
            },
            contractPass(query) {
                this.formInline.aaa = query;
                this.formInline.taskid = this.taskid;
                this.formInline.instid = this.instid;
                this.formInline.salesCity = "";
                ss.contractService.contractPassXianShang(this.formInline).then(rd => {
                    this.$msg.alerts("提交成功！", () => {
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列表
                        this.$router.push({
                            path: '/personal/dealCenter'
                        })
                    })
                })
            },
            fillCusName(data) {
                let obj = {};
                obj = this.customerList.find((item) => {
                    return item.usercode === data;
                });
                console.log(obj, "obj")
                if (obj != undefined) {
                    this.formInline.customerCode = obj.usercode;
                } else {
                    this.formInline.customerName = this.formInline.customerCode
                }
            },
            //查询渠道
            selectChannel() {
                ss.Dictservice.listbycategory("sales_region").then(response => {
                    this.qudao = response;
                })
            },
            getQudao(value) {
                console.log(value);
                var jsonObj = value
                var jStr = '';
                for (var item in jsonObj) {
                    jStr += jsonObj[item] + ",";
                }
                this.channels = jStr.substring(0, jStr.lastIndexOf(','))
            },
            lianqunOptions(value) {
                console.log("value", value);
                var jsonObj = value
                var jStr = '';
                for (var item in jsonObj) {
                    jStr += jsonObj[item] + ",";
                }
                this.formInline.lianqun = jStr.substring(0, jStr.lastIndexOf(','))
                console.log(this.formInline.lianqun);
                if (this.formInline.lianqun.includes("X02") || this.formInline.lianqun.includes("X01")
                    || this.formInline.lianqun.includes("X08") || this.formInline.lianqun.includes("X09") || this.formInline.lianqun.includes("X10")
                    || this.formInline.lianqun.includes("X05") || this.formInline.lianqun.includes("X06")
                ) {
                    this.isCt = true;
                } else {
                    this.isCt = false;
                }
            },
            seeQudao(value) {
                console.log(value);
                var jsonObj = value
                var jStr = '';
                for (var item in jsonObj) {
                    jStr += jsonObj[item] + ",";
                }
                this.channels = jStr.substring(0, jStr.lastIndexOf(','))
            },
            getAreaCity() {
                let areas = this.formInline.saleareaCode.split(",");
                let ss1 = [];
                console.log("areas", areas);
                let promises = []; // 创建一个存储异步操作的Promise数组
                for (var i = 0; i < areas.length; i++) {
                    let promise = ss.Dictservice.getDictByCateCode("YlSalesArea_chanpin", areas[i])
                        .then(response => {
                            ss1.push(response.refid);
                        });
                    promises.push(promise); // 将每个异步操作的Promise添加到数组中
                }

                Promise.all(promises) // 等待所有异步操作完成
                    .then(() => {
                        var s2 = ss1.join(",");
                        ss.UserService.getCityByArea(s2).then(rd => {
                            this.salesCity = rd.msg;
                        });
                    });
            },


            // 关闭新手引导页
            closeIt() {
                this.showOrhide = false;
                if (this.checked) {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                } else {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                }
            },
            fillCusCode() {
                this.formInline.customerCode = this.formInline.customerName;
            },
            nextStep(i) {
                if (this.status == 1) {
                    this.status = 2;
                } else if (this.status == 2) {
                    if (this.checked) {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    }
                }
            },
            // 时间戳转换日期
            timestampToTime(timestamp) {
                var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                let Y = date.getFullYear();
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
                let D = date.getDate().toString().padStart(2, 0);
                let h = date.getHours() + ':';
                let m = date.getMinutes() + ':';
                let s = date.getSeconds();
                return Y + '-' + M + '-' + D;//+h+m+s
            },
            /**
             * 查询当天日期
             */
            // getNowDate(d) {
            //   const timeOne = new Date()
            //   const year = timeOne.getFullYear()
            //   let month = timeOne.getMonth() + 1
            //   let day = timeOne.getDate()
            //   month = month < 10 ? '0' + month : month
            //   day = day < 10 ? '0' + day : day
            //   const NOW_MONTHS_AGO = `${year}-${month}-${day}`
            //   return NOW_MONTHS_AGO
            // },
            stRentTime() {
                let that = this;
                that.formInline.contractStarttime = that.timestampToTime(new Date().getTime());// 默认开始日期
                that.formInline.contractEndtime = that.timestampToTime(new Date().getTime() + that.formInline.rentTime * 24 * 60 * 60 * 1000);// 默认结束日期
                for (var i = 0; i < this.rentTimeList.length; i++) {
                    var priceData = this.rentTimeList[i];
                    if (priceData.rentTerm == this.formInline.rentTime) {
                        that.formInline.rentPrice = priceData.rentPrice;
                        if (this.formInline.zlList) {
                            for (var j = 0; j < this.formInline.zlList.length; j++) {
                                var zl = this.formInline.zlList[j];
                                if (zl.priceType == 'ZL01') {
                                    zl.productUnitPrice = priceData.rentPrice;
                                }
                            }
                        }
                    }
                }
            },
            setZlDate() {
                let that = this;
                var newDate = new Date(that.formInline.contractStarttime);
                that.formInline.contractEndtime = that.timestampToTime(newDate.getTime() + 364 * 24 * 60 * 60 * 1000);// 默认结束日期

                console.log(that.formInline.contractEndtime);

                if (that.formInline.contractEndtime < that.timestampToTime(new Date().getTime())) {
                    that.formInline.contractEndtime = that.timestampToTime(new Date().getTime());
                }

            },
            cancel() {
                this.$router.push("contract-list");
            },
            getCustomerList() {
                ss.contractService.getCustomerList({usertype: 1, status: 1}).then(rd => {
                    this.customerList = rd;
                });
            },
            changeArea(query) {
                this.formInline.salesCity = '';
                var areas = [];
                areas.push(query.refid)
                ss.UserService.getCityByArea(areas).then(rd => {
                    console.log(rd);
                    this.salesCity = rd.msg;
                })
            },
            getCitys(value) {
                this.citys = value.join(",")
            },
            changeDlsType(value) {
                this.lianqunList = []
                this.formInline.salechannelCode = '';
                if (value == '国内市场经销合同') {
                    this.isCt1 = true;
                    this.isNA9 = false;
                    this.isKs1 = false;
                    this.isSj1 = false;
                    this.isHh1 = false;
                    this.isXueYe = false;
                } else if (value == '平台商合同') {
                    this.isCt1 = true;
                    this.isNA9 = false;
                    this.isKs1 = false;
                    this.isSj1 = false;
                    this.isHh1 = false;
                    this.isXueYe = false;
                } else if (value == '康盛合同') {
                    this.isCt1 = false;
                    this.isNA9 = false;
                    this.isKs1 = true;
                    this.isSj1 = false;
                    this.isHh1 = false;
                    this.isXueYe = false;
                } else if (value == '鸿鹄合同') {
                    this.isCt1 = false;
                    this.isNA9 = true;
                    this.isKs1 = false;
                    this.isSj1 = false;
                    this.isHh1 = false;
                    this.isXueYe = false;
                } else if (value == '海盛杰合同') {
                    this.isCt1 = false;
                    this.isNA9 = false;
                    this.isKs1 = false;
                    this.isSj1 = true;
                    this.isHh1 = false;
                    this.isXueYe = false;
                } else if (value == '厚宏合同') {
                    this.isCt1 = false;
                    this.isNA9 = false;
                    this.isKs1 = false;
                    this.isSj1 = false;
                    this.isHh1 = true;
                    this.isXueYe = false;
                } else if (value == '国内市场经销合同-血液') {
                    this.isCt1 = false;
                    this.isNA9 = false;
                    this.isKs1 = false;
                    this.isSj1 = false;
                    this.isHh1 = false;
                    this.isXueYe = true;
                }
            },
            //框架合同table页
            tabchange(i) {
                console.log(i);
                this.tabIndex = i;
                if (this.tabIndex == '1') {
                    this.tabflag = true;
                } else if (this.tabIndex == '3') {
                    this.tabflag = true;
                } else if (this.tabIndex == '2') {
                    this.tabflag = true;
                }
            },
            selectPageAll() {
                this.q2.agentName = this.formInline.customerCode;
                this.q2.contractIdNew = this.formInline.id;
                this.q2.status = 1;
                ss.grabOrderApi.selectPageTargetAgainstUser(this.q2).then(res => {
                    console.log(res)
                    console.log("total", res.total)
                    this.tableData2 = res.records
                    this.q2.total = res.total
                    console.log("table", this.tableData2)
                })
            },
            queryMb() {
                this.q3.agentNameLike = this.formInline.customerName;
                this.q3.salesRegionCode = this.formInline.salechannelCode;
                ss.fanli.pagefanliXsjl(this.q3).then(rd => {
                    this.q3.total = rd.total;
                    this.tableData3 = rd.records;
                });

            },
            showAgentList(value) {
                ss.UserService.selectAgentByName(value).then(rd => {
                    console.log(rd);
                    this.oneAgentList = rd.msg;
                })
            },
            changeAgent(value) {
                this.formInline.oneLevelAgentName = value.customerName
                this.formInline.oneLevelAgent = value.usercode
            },
            fieldChange() {
                this.formInline.salechannelCode = '';
            }
        },
        mounted() {
            let instid = this.$route.query.instid;
            if (this.$route.query.key != null && this.$route.query.key != '') {
                this.contractId = this.$route.query.key;
            }
            if (null == instid || instid == '') {
                this.disabled = true;
                this.fileFlag = false;
                this.lastflag = false;
                if (this.contractId != null) {
                    ss.contractService.selectByIdAgent(this.contractId).then(rd => {
                        this.guanlianxiangmFlag = false;
                        this.formInline = rd.obj;
                        if (this.formInline.lianqun != null && this.formInline.lianqun) {
                            let s = this.formInline.lianqun;
                            this.getLianquns(s)
                        }
                        if (this.formInline.saleareaCode != null && this.formInline.saleareaCode) {
                            this.getAreaCity();
                        }
                        if (this.formInline.salesCity != null && this.formInline.salesCity) {
                            console.log(this.formInline.salesCity)
                            let s = this.formInline.salesCity;
                            this.getCity(s)
                        }
                        this.selectPageAll();
                        this.queryMb()
                    })
                } else {
                    var coflag = {
                        codeflag: 6
                    }
                    ss.contractService.getContractCode(coflag).then(rd => {
                        var date = new Date();
                        var year = date.getFullYear();
                        var month = date.getMonth() + 1;
                        var day = date.getDate();
                        if (month < 10) {
                            month = 0 + month.toString();
                        }
                        this.formInline.id = year.toString() + month.toString() + day.toString() + "HT" + rd;
                        this.contractId = this.formInline.id;
                        console.log(year.toString() + month.toString() + day.toString());
                        console.log(this.formInline.id);
                    })
                    this.selectPageAll();
                    this.queryMb()
                }
                ;
            }


        },
        created() {
            let instid = this.$route.query.instid;
            this.instid = this.$route.query.instid;
            this.taskid = this.$route.query.taskid;
            if (this.$route.query.isFb == 1) {
                this.isFb = true;
            }
            this.tabIndex = '1';
            this.selectChannel();
            if (null != instid && instid != '') {
                this.disabled = true;
                this.chankanflag = true;
                //根据instid查询数据
                ss.contractService.getContractByInstid(instid).then(rd => {
                    console.log('rdrdrd', rd)
                    if (rd.f) {
                        this.formInline = rd.msg;
                        this.formInline.salesCity = rd.msg.salesCity;
                        this.contractId = this.formInline.id;

                        if (this.formInline.contractAgent == '11' || this.formInline.contractAgent == '12' || this.formInline.contractAgent == '13') {
                            this.isKa = true;
                        }

                        if (this.formInline.lianqun != null && this.formInline.lianqun) {
                            let s = this.formInline.lianqun;
                            this.getLianquns(s)
                        }
                        if (this.formInline.saleareaCode != null && this.formInline.saleareaCode) {
                            this.getAreaCity();
                        }
                        if (this.formInline.salesCity != null && this.formInline.salesCity) {
                            let s = this.formInline.salesCity;
                            this.getCity(s)
                        }
                        this.selectPageAll();
                        this.queryMb()
                    }
                })
            }
            //判断审批节点
            if (null != this.$route.query.taskid) {
                ss.taskservice.getTaskByTaskid(this.$route.query.taskid).then(result => {
                    console.log("resultresultresult", result.name);
                    //判断大区经理审批节点控制审批按钮
                    if (result.name == '大区审核'
                        || result.name == '产业总'
                        || result.name == '网络运营经理'
                        || result.name == '总监审批'
                        || result.name == '总监审核'
                        || result.name == '渠道平台'
                        || result.name == '市场审批'
                        || result.name == '省区审核') {
                        this.daquflag = true;
                        this.lastflag = false;
                        this.fileFlag = false;
                        console.log('暂存')
                    } else if (result.name == '总部确认'
                        || result.name == '鸿鹄审批' || result.name == '总部确认直单'
                        || result.name == '疫苗审批'
                        || result.name == '血液审批'
                        || result.name == '鸿鹄'
                        || result.name == '康盛'
                        || result.name == '厚宏'
                        || result.name == '血液'
                        || result.name == '海盛杰'
                        || result.name == '传统审批'
                        || result.name == '传统直单审批'
                        || result.name == '销售总监'
                    ) {
                        this.daquflag = false;
                        this.lastflag = true;
                        this.fileFlag = false;
                        console.log('暂存')
                    }
                })
            }
            this.getCustomerList();
            if (this.$store.getters.hasRole('swyl_quyujl') || this.$store.getters.hasRole('swyl_daqujl') ||
                this.$store.getters.hasRole('swyl_xiaoshoujl_honghu') || this.$store.getters.hasRole('swyl_xiaoshoujl_kangsheng')
            ) {
                var data = {};
                data.usercode = this._user.usercode;
                data.type = 18;
                //获取当前登录人的公司
                ss.resourcePool.getAuthByCode(data).then(rd => {
                    var list = rd.msg;
                    for (var i = 0; i < list.length; i++) {
                        var data = list[i];
                        if (data.code == "0PN0" || data.code == "1R60" || data.code == "1JC0") {
                            this.shichang = false;
                        }
                    }
                })
            }
        }
    }
</script>

<style>
    /* .h-formbLine .el-form-item__label{
        width: 18%;
    } */
    .yearIcon .el-input:after {
        content: '天';
        font-size: 0.18rem;
        color: #b8b6b6;
        /* font-weight: bold; */
        position: absolute;
        right: 0.15rem;
    }

    .weekplandetail1 .h-formbLine .el-form-item__label {
        width: 11%;
        text-align: right;
    }

    .weekplandetail23 .h-formbLine .el-form-item__label {
        width: 34%;
        text-align: right;
    }

    .weekplandetail23 .h-formbLine .el-form-item__content {
        width: 66%;
    }

    .weekplandetail23 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .weekplandetail23 .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .weekplandetail23 .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 10.4%;
    }

    .weekplandetail23 .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 89.6%;
    }

    .ljjtips .el-table tbody td .cell {
        padding: 0.2rem 0.1rem;
    }

    .outerCon {
        display: flex;
        justify-content: flex-start;
        width: 100%;
        margin-bottom: 30px;


    .tabBtn {
        background-color: #f0f5fb;
        padding: 10px;
        border: 1px solid #dae0f0;
        margin-right: 10px;
        color: #282c2f;
        cursor: pointer;
    }

    .hsalesCity {
        width: 25%;
        padding-right: 0.5rem
    }

    .tabBtnAc {
        color: white;
        background-color: #2785e7;
    }

    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }
    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }
    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step1 {
            top: 2.6rem;
            left: 3.15rem;
            width: 4rem;
            height: 1.7rem;
        }

        .step2 {
            top: 4.55rem;
            left: 3.9rem;
            width: 13.5rem;
            height: 2.3rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.65rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
        .hsalesCity {
            width: 25%;
            padding-right: 0.5rem
        }
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
      border: none;
      border-bottom: 1px solid #dcdfe6;
    }
    ::v-deep .el-textarea__inner{
      border-radius: 0;
      border: none;
      border-bottom: 1px solid #dcdfe6;
    }
    //::v-deep .el-tag {
    //  padding: 0 0.1rem;
    //}
    ::v-deep .el-upload-list__item{
      line-height: 40px;
    }
    ::v-deep .el-upload-list__item .el-icon-close{
      top: 13px;
      right: 0;
    }
    ::v-deep .el-form-item{
      margin-bottom: 0;
    }
    ::v-deep .el-input__inner{
      line-height: 20px;
      height: 20px;
    }
    ::v-deep .saleFile .el-form-item__label{
      line-height: 20px;
    }
    .salesCityStyle{
      border: 1px solid #dcdfe6;
      border-radius: 10px;
    }
    ::v-deep .el-form-item__error{
      position: static;
    }
    ::v-deep .el-tag {
      padding: 0 0.1rem;
    }
    ::v-deep .el-form-item__label{
      font-size: 12px;
    }
    ::v-deep .el-upload-list__item{
      font-size: 12px;
    }
    .industryBox{
      border-bottom: 1px solid #dcdfe6;
    }
</style>
